// react
import React from 'react';

// mui
import { Container, Stack, Divider } from '@mui/material';

export interface PageTemplateProps {
  headerSlot?: React.ReactNode;
  contentSlot?: React.ReactNode;
  maxWidth?: false | 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  /** Override maxWidth for the header container only. */
  headerMaxWidth?: false | 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  /** Remove vertical padding from the outer Stack. */
  disableGutters?: boolean;
  /** Remove bottom padding from the outer Stack (useful when a footer is handled externally). */
  disablePaddingBottom?: boolean;
}

/**
 * PageTemplate is a basic page layout template with padding and a maxWidth
 * constraint. It includes a divider between two sections of content.
 */
export const PageTemplate = ({
  headerSlot,
  contentSlot,
  maxWidth = 'md',
  headerMaxWidth,
  disableGutters = false,
  disablePaddingBottom = false,
}: PageTemplateProps) => {
  return (
    <Stack
      sx={{
        minHeight: '100%',
        paddingTop: { xs: 2, sm: 4 },
        paddingBottom: disablePaddingBottom ? 0 : { xs: 2, sm: 4 },
        gap: { xs: 3, sm: 5 },
        overflow: 'auto',
      }}
    >
      {headerSlot && (
        <Container maxWidth={headerMaxWidth ?? maxWidth}>
          {headerSlot}
        </Container>
      )}
      <Container maxWidth={maxWidth} disableGutters={disableGutters}>
        {contentSlot}
      </Container>
    </Stack>
  );
};

PageTemplate.displayName = 'PageTemplate';
export default PageTemplate;
